<template>
  <v-layout flat class="white" row wrap r>
    <h3
      class="flex xs12 my-3 py-2 px-3 grey lighten-5 subheading font-weight-bold teal--text"
    >
      {{ prettySection(section) }}
    </h3>

    <template v-for="(q, index) in sectionQuestions">
      <v-flex xs12 md6 px-5 :key="`p${index}`">
        <p class="body-2 grey--text text--darken-3 font-weight-medium mb-0">
          <strong class="primary--text">Q{{ index + 1 }}.</strong>
          <span
            class="primary--text body-1"
            v-text="q.compulsory ? ' (Compulsory) ' : ''"
          />
          {{ q.details }}
        </p>
        <v-menu
          offset-y
          :key="`m${index}`"
          :disabled="!can('edit_assessments')"
        >
          <p slot="activator" class="body-2 font-weight-medium pt-2">
            <span class="teal--text mr-1">Score:</span>
            <span :class="{ 'font-weight-bold  ': q.answer == -1 }">
              (
              <span
                class="grey--text lighten-1"
                v-if="assessment.type == 'Re-Assessment'"
                >{{ `${prettyAnswer(q.old_answer)},` }}</span
              >
              {{ prettyAnswer(q.answer) }}
              )
            </span>
          </p>

          <v-list three-line>
            <v-card
              flat
              tile
              class="px-3 question_card"
              :key="`answered${index}${a}`"
              v-for="(item, a) in answers"
              @click="answerChanged(q, item.value)"
            >
              <a>
                <strong class="primary--text">
                  {{ `M&R. ${item.value}` }}
                </strong>
                <p class="grey--text text--darken-3">
                  {{ q[`mr_${item.value}`] }}
                </p>
              </a>
            </v-card>
            <v-card
              flat
              tile
              v-if="q.pro_rated"
              class="px-3 question_card"
              @click="answerChanged(q, -1)"
            >
              <a>
                <strong class="primary--text">PRO-RATED</strong>
                <p class="grey--text text--darken-3">{{ q[`mr_5`] }}</p>
              </a>
            </v-card>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex :key="`answer${index}`" xs12 md6 px-5>
        <p class="body-2 grey--text text--darken-2 mb-0">
          <strong class="primary--text">{{
            `M&R. ${prettyAnswer(q.answer)}`
          }}</strong>
          {{ q.answer != "N/A" ? q[`mr_${q.answer >= 0 ? q.answer : 5}`] : "" }}
        </p>
      </v-flex>
      <v-divider :key="`hr${index}`" class="my-3 flex xs12" />
    </template>
    <v-flex xs12 class>
      <score-card :score_cards="score_cards" :cso="cso" />
    </v-flex>
    <v-flex xs12 row wrap mt-4 class="di-flex justify-end px-3 pb-2">
      <v-btn flat @click="$emit('back')">Back</v-btn>
      <v-btn class="mr-0" color="primary" @click="$emit('next')">Next</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Assessment",
  components: { scoreCard: () => import("./scoreCard") },
  props: {
    section: String,
    lessThan: { default: 5 },
    cso: { default: () => {} },
    questions: { default: () => [] },
    score_cards: { default: () => [] },
    assessment: { default: () => ({ type: "Primary-Assessment" }) }
  },
  data() {
    return {
      loading: false,
      answers: [
        { text: "0", value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 }
      ]
    };
  },
  computed: {
    isEditing() {
      return !!this.$route.params.id;
    },
    sectionQuestions: vm =>
      vm.questions.filter(
        x =>
          x.section == vm.section &&
          (x.old_answer < vm.lessThan || x.old_answer == "N/A")
        // x => x.section == vm.section
      )
  },
  methods: {
    validateForm() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) this.save();
        else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    },
    answerChanged(question, answer) {
      this.axios
        .post("/answers", {
          answer,
          cso_id: this.cso.id,
          question_id: question.id,
          assessment_id: this.assessment.id
        })
        .then(res => {
          question.answer = answer;
          this.$emit("answerChanged", res.data.data);
        });
    }
  }
};
</script>
<style>
.question_card:hover {
  border-left: 5px solid #08c;
}
</style>
